/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'anysize': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M3 2a1 1 0 1 1 0-2h4a1 1 0 1 1 0 2H3Zm8 0h4a1 1 0 0 0 0-2h-4a1 1 0 0 0 0 2Zm8 0h2a1 1 0 0 1 .867.5 1 1 0 1 0 1.73-1.001A2.999 2.999 0 0 0 21 0h-2a1 1 0 0 0 0 2Zm3 3.939v4a1 1 0 0 0 2 0v-4a1 1 0 0 0-2 0Zm0 8v4a1 1 0 1 0 2 0v-4a1 1 0 0 0-2 0Zm-.11 7.517A1 1 0 0 1 21 22h-1.877a1 1 0 0 0 0 2H21a3 3 0 0 0 2.67-1.63 1 1 0 1 0-1.78-.914ZM15.124 22h-4a1 1 0 0 0 0 2h4a1 1 0 1 0 0-2Zm-8 0h-4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2ZM2 20.184v-4a1 1 0 1 0-2 0v4a1 1 0 0 0 2 0Zm0-8v-4a1 1 0 1 0-2 0v4a1 1 0 0 0 2 0Zm0-8a1 1 0 1 1-2 0V3A3 3 0 0 1 2.606.026a1 1 0 0 1 .26 1.983A1 1 0 0 0 2 3v1.184Z" fill-rule="nonzero" _fill="#adadad"/>'
  }
})
